/**所有实体 */
const Entity = {
  SALE_PAYBACK: { entityType: "1", mainTable: "pm_sale_payback", processName: "销售收款" },//销售收款审批(1)
  PURCHASE_PAYMENT: { entityType: "2", mainTable: "pm_purchase_payment", processName: "采购付款" },//采购付款审批(2)
  REIMBURSEMENT_PAYMENT: { entityType: "3", mainTable: "pm_reimbursement_payment", processName: "其他付款"},//其他付款审批(3)
  OPERATE_REIMBURSEMENT_PAYMENT: { entityType: "4", mainTable: "pm_operate_reimbursement_payment", processName: "费用报销"},//费用报销审批(4)
  LOAN_PAYMENT: { entityType: "5", mainTable: "pm_loan_payment", processName: "借款审批" },//借款审批(5)
  LOAN_PAYBACK: { entityType: "6", mainTable: "pm_loan_payback", processName: "还款审批"  },//还款审批(6)
  WORK_REPORT: { entityType: "7", mainTable: "pm_project_report_work_main", processName: "报工申请"  },//报工审批(7)
  BOOD_PAYMENT: { entityType: "8", mainTable: "pm_bood_payment", processName: "保证金" },//保证金审批(8)
  WORK_ORDER: { entityType: "9", mainTable: "pm_work_order" , processName: "协同工单审批" },//协同工单审批(9)
  SALE_INVOICE_APPLY: { entityType: "10", mainTable: "pm_sale_invoice_apply", processName: "申请开票"},//申请开票(10)
  PROJECT_PAYBACK: { entityType: "11", mainTable: "pm_project", processName: "收入项目"},//收入项目(11)
  PROJECT_DAILY: { entityType: "12", mainTable: "pm_project", processName: "日常项目" },//日常项目(12)
  PROJECT_CONSTRUCTION: { entityType: "13", mainTable: "pm_project", processName: "施工项目" },//施工项目(13)
  PROJECT_DEV: { entityType: "14", mainTable: "pm_project", processName: "研发项目" },//研发项目(14)
  CUSTOMER: { entityType: "15", mainTable: "pm_customer", processName: "客户" },//客户(15)
  OFFICE_CLAIM: { entityType: "16", mainTable: "pm_office_claim", processName: "办公用品领用" },//办公用品领用(16)
  SALE_DEAL: { entityType: "17", mainTable: "pm_sale_deal", processName: "销售合同" },//销售合同(17)
  PURCHASE_DEAL: { entityType: "18", mainTable: "pm_purchase_deal", processName: "采购正式合同" },//采购正式合同(18)
  FRAME_PURCHASE_DEAL: { entityType: "18:1", mainTable: "pm_purchase_deal", processName: "采购框架合同" },//采购框架合同(18:1)
  LABOR_PURCHASE_DEAL: { entityType: "18:2", mainTable: "pm_purchase_deal", processName: "采购劳务分包合同" },//采购劳务分包合同(18:2)
  SUPPLIER: { entityType: "19", mainTable: "pm_supplier", processName: "供应商" },//供应商审批(19)
  CONSTRUCTION_SUPPLIER: { entityType: "19:1", mainTable: "pm_supplier", processName: "施工单位" },//施工单位审批(19:1)
  PURCHASE_REQUISITION: { entityType: "20", mainTable: "pm_purchase_requisition", processName: "采购申请" },//采购申请审批(20)
  PURCHASE_ORDER: { entityType: "21", mainTable: "pm_purchase_order", processName: "采购订单" },//采购订单审批(21)
  PURCHASE_ORDER_PAYMENT: { entityType: "22", mainTable: "pm_purchase_order_payment", processName: "采购订单付款" },//采购订单付款审批(22)
  STATEMENT_PAYMENT: { entityType: "23", mainTable: "pm_statement_payment", processName: "对账单付款" },//对账单付款审批(23)
  GOODS: { entityType: "24", mainTable: "pm_goods", processName: "商品" },//商品(24)
  MATERIAL_CLAIM: { entityType: "25", mainTable: "pm_material_claim", processName: "物料领用" },//物料领用(25)
  INPUT_INVOICE: { entityType: "26", mainTable: "pm_input_invoice", processName: "进项发票"},//进项发票新建(26)
  pm_engineering_funds_payment: { entityType: "27", mainTable: "pm_engineering_funds_payment", processName: "工程款付款"},//工程款付款(27)
  SUPPLEMENTARY_SALE_DEAL: { entityType: "30", mainTable: "pm_sale_deal", processName: "订单补充合同"},//订单补充合同(30)
  SUPPLEMENTARY_PURCHASE_DEAL: { entityType: "31", mainTable: "pm_purchase_deal", processName: "采购补充合同" },//采购补充合同(31)
}
/**项目模块常量 */
// 项目状态
const ProjectStatus = {
  0: "未开始",
  1: "进行中",
  2: "已超时",
  3: "已归档",
};
// 项目类型
const ProjectType = {
  1: "收入",
  2: "日常",
  3: "研发",
  4: "施工",
}
//即刻智能corpId
const CorpId = 'dinge146a3996b412dd8'
// 体验组织corpId
// const CorpId = 'dinga85efb9c4ba09091ee0f45d8e4f7c288'

export default {
  ProjectStatus,
  ProjectType,
  Entity,
  CorpId,
  
}

